import { PlayCircleIcon, PlayIcon } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/components/ui/tooltip';
import { Typography } from '~/components/ui/typography';
import { YouTubeDialog } from '~/components/ui/youtube-dialog';

export interface TestimonialItem {
  imageSrc: string;
  imageAlt: string;
  quote: string;
  author: {
    name: string;
    location: string;
    videoSrc: string;
  };
}

export function TestimonialGrid({ testimonials }: { testimonials: TestimonialItem[] }) {
  return (
    <div className="m-auto mt-12 grid w-fit grid-cols-1 items-center justify-center gap-x-32 gap-y-20 md:grid-cols-2">
      {testimonials.map((testimonial, index) => (
        <Testimonial key={index} {...testimonial} />
      ))}
    </div>
  );
}

export function Testimonial({ author, imageAlt, imageSrc, quote }: TestimonialItem) {
  return (
    <div className="flex w-fit flex-row items-center gap-3">
      <div className="relative">
        <img
          loading="lazy"
          src={imageSrc}
          alt={imageAlt}
          className="pointer-events-none h-16 min-h-16 w-16 min-w-16 select-none rounded-full object-cover"
        />
        <div className="absolute bottom-0 right-0 font-mono text-xs">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <YouTubeDialog embedUrl={author.videoSrc}>
                  <div className="mb-2 cursor-pointer rounded-full bg-black p-[2px]">
                    <PlayIcon color="black" fill="white" size={16} />
                  </div>
                </YouTubeDialog>
              </TooltipTrigger>
              <TooltipContent>View Testimonial</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <div className="flex w-fit flex-col">
        <p className="text-6xl leading-[0] text-[#98E021]">“</p>
        <Typography className="max-w-[420px]">{quote}</Typography>
        <Typography variant="smallText" className="mt-3">
          {author.name}, {author.location}
        </Typography>
        <YouTubeDialog embedUrl={author.videoSrc}>
          <Typography variant="smallText" className="mt-1 cursor-pointer font-light underline">
            View Testimonial {'>'}
          </Typography>
        </YouTubeDialog>
      </div>
    </div>
  );
}
